import * as React from "react";
import { useTranslation } from "react-i18next";
import ChipsCell from "components/common/ChipsCell";
import { TacticTechnique } from "security-app/components/SecurityEvents/Alerts/ColumnRenderers";
const TacticsTechniquesSummary = ({ eventDefinition }) => {
  var _a;
  const { t } = useTranslation("enterprise_security_app");
  const items = (_a = eventDefinition.tactics_techniques) != null ? _a : [];
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("dt", null, t("tactics_techniques.label")), /* @__PURE__ */ React.createElement("dd", null, items.length ? /* @__PURE__ */ React.createElement(ChipsCell, { items, truncate: false, renderItemContent: (id) => /* @__PURE__ */ React.createElement(TacticTechnique, { value: id }) }) : /* @__PURE__ */ React.createElement("em", null, t("tactics_techniques.none"))));
};
export default TacticsTechniquesSummary;
